import {useCallback} from "react";
import {copyToClipboard} from "../../utils/common";

const useCopyToClipboard = (referralRef, shortUrl, setNotify) => {
    return useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboard(shortUrl, referralRef.current)
            .then(() => {
                setNotify({message: 'Link copied', type: 'info'});
            })
            .catch(() => {
                setNotify({message: 'Error while copying', type: 'error'});
            });
    }, [shortUrl, referralRef, setNotify]);
};

export default useCopyToClipboard;

